// extracted by mini-css-extract-plugin
module.exports = {"flex-contain":"index-module_flex-contain_2e3cu"};